// Copyright (c) 2023 Alife Health - All Rights Reserved
import React from 'react';

import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';
import 'swiper/css';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { useMixpanel } from '../../../functions/Mixpanel';

import * as style from './Carousels.module.css';

type CarouselProps = {
  readMorePath?: string;
  showReadMore?: boolean;
  showContactUs?: boolean;
  elements: JSX.Element[];
};
const Carousel = ({
  elements,
  readMorePath,
  showReadMore,
  showContactUs,
}: CarouselProps) => {
  const { mixpanel } = useMixpanel();

  return (
    <div className={style.container}>
      <div className={style.innerContainer}>
        <div className={style.cards}>
          <Swiper
            modules={[Navigation]}
            navigation={{
              nextEl: '.image-swiper-button-next',
              prevEl: '.image-swiper-button-prev',
              disabledClass: `${style.disabledButton}`,
            }}
            slidesPerView="auto"
            spaceBetween={24}
            style={{
              overflow: 'visible',
            }}
          >
            {elements.map((item, index) => {
              return (
                <SwiperSlide className={style.scrollCard} key={index}>
                  {item}
                </SwiperSlide>
              );
            })}

            {showReadMore && (
              <SwiperSlide>
                <div className={style.readMoreContainer}>
                  <a href={`/research/${readMorePath || ''}`}>
                    <button
                      className={`btn ${style.readMore}`}
                      onClick={() => mixpanel.track('Read More')}
                    >
                      Read more
                    </button>
                  </a>
                </div>
              </SwiperSlide>
            )}
          </Swiper>
        </div>
        <div className={style.bottomBar}>
          {showContactUs && (
            <p className={style.contactUs}>
              Interested in participating in a study?{' '}
              <a href="/contact">Contact us.</a>
            </p>
          )}
          {elements.length > 2 && (
            <div className={style.nextIcons}>
              <button
                className={`swiper-button image-swiper-button-prev ${style.arrowButton}`}
              >
                <IconChevronLeft
                  size="32px"
                  color="#21263A"
                  fill="white"
                  className="tw-m-auto"
                />
              </button>
              <button
                className={`swiper-button image-swiper-button-next ${style.arrowButton}`}
              >
                <IconChevronRight
                  size="32px"
                  color="#21263A"
                  className="tw-m-auto"
                />
              </button>
            </div>
          )}
        </div>
      </div>
      <div></div>
    </div>
  );
};

export { Carousel };
